import styled from 'styled-components';

const HomepageWrapper = styled.div`
  padding: 0 20px;

  .cards-container {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    margin: 40px auto;
  }
`;

export default HomepageWrapper;
